
'use strict';


export default class BaptistProduct extends HTMLElement {

    constructor () {
        super();



        if ( !this.getAttribute('product-id'))
            throw 'Attribute "product-id" not set';

        if ( !this.getAttribute('product-unit-id'))
            throw 'Attribute "product-unit-id" not set';



        this.querySelector('.add-to-cart')
            .addEventListener('click', () => {
                window.store.product.addToCart({
                    id: this.getAttribute('product-unit-id'),
                    cartQuantity: 1,
                    type_: 'Products',
                });
            });



        this.querySelector('.compare-label input')
            .addEventListener('change', () => {
                window.store.product.compare(
                    this.getAttribute('product-id'),
                )
            });
    }

}
